import "./../../bindings/bao-searcher";
import "./../../bindings/bao-toolbar2";
import * as $ from "jquery";
import * as ko from "knockout";
import GenericListSearchTab from "./../../factories/generic-list-search-tab";
import TabPage from "./../../factories/tab-page";
import { baseZIndex } from "devextreme/ui/overlay";


class MandatorUserTab extends GenericListSearchTab {
    Mandator: any;

    constructor(public TabPage: TabPage, parent: any) {
        super(TabPage, parent);
        this.Parent = parent;
        this.Mandator = parent;
        this.Models.subscribe(() => {
            this.Selection([]);
        });
        this.Subscribe(this.Parent.TabPage.DirtyFlag, (isNew) => {
            this.ToggleToolbarButtons();
        });
    }

    PermissionAdd = "MandatorUserTabAdd";
    PermissionRemove = "MandatorUserTabRemove";
    ControllerUrl = "MandatorUserTab"

    SearchType(): string {
        return "Uadm-User";
    }

    SearchConfig: Models.BaoSearchDialogConfig = {
        SearchType: this.SearchType(),
        AutoSearch: true,
        MultiSelect: false,
        ObjectId: ko.observable<string>(),
        ObjectValue: "PrimaryKeyValue",
        //CustomFilter: { SessionTabId: this.SessionTabId },
        ApplyItemCallback: (searchVM) => {
            this.SaveSearchItem(searchVM.SelectedItem());
        }
    };

    ToggleToolbarButtons() {
        let _this = this;
        ko.utils.arrayForEach(this.ToolbarButtons(), (button) => {
            let key = ko.unwrap(button.ActionKey);
            let enabled = <KnockoutObservable<boolean>>(button.Enabled);
            if (key == _this.PermissionAdd) {
                enabled(true);
            }
            else if (key == _this.PermissionRemove) {
                enabled(_this.Selection() != null && _this.Selection().length > 0);
            }

            // if Tab isNew the Buttons musst be disabled!
            if(_this.Parent.IsNew() == true){
                enabled(false);
            }
        });
    }

    ItemCompleteCheck(item: any): JQueryPromise<boolean> {
        return $.Deferred<boolean>().resolve(true).promise();
    }

    CustomFilter(): Models.HashObject[] {
        return null;
    }
}
export default MandatorUserTab;